import React from 'react';
import { LandingComponent } from 'app/types';
import Text from 'common/components/Text/Text';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const MarkdownPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const titleSize = (size?: string) => {
    if (size === 'large') {
      return '3rem';
    } else if (size === 'normal') {
      return '30px';
    } else if (size === 'small') {
      return '18px';
    }
    return;
  };

  return (
    <div id={landing_cmp.html_id} key={landing_cmp.id} className={landing_cmp.class_name}>
      {landing_cmp.config.section_title && (
        <div
          style={{
            fontSize: '20px',
            color: landing_cmp.config.section_title_color,
            fontWeight: '700',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {landing_cmp.config.section_title}
          <div
            style={{ width: '87px', height: '8px', background: '#E8F3FE', alignSelf: 'center' }}
          ></div>
        </div>
      )}
      {landing_cmp.config.title && (
        <div
          style={{
            fontSize: titleSize(landing_cmp.config.title_size),
            color: landing_cmp.config.title_color,
            fontWeight: '700',
            width: landing_cmp.config.style === 'homepage' ? '75%' : '90%',
          }}
        >
          {landing_cmp.config.title}
        </div>
      )}
      {landing_cmp.config.description && (
        <Text
          size={16}
          weight={500}
          inlineStyle={{
            color: landing_cmp.config.description_color
              ? landing_cmp.config.description_color
              : landing_cmp.config.title_color,
          }}
        >
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>
            {landing_cmp.config.description}
          </ReactMarkdown>
        </Text>
      )}
    </div>
  );
};

export default MarkdownPreview;
